import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AdminGuard from 'utils/route-guard/AdminGuard';
import { Navigate } from 'react-router-dom';
import { SocketProvider } from 'contexts/socketContext';

// page routing
const MicrophoneRecognitionPage = Loadable(lazy(() => import('views/microphone-recognition')));
const FileRecognitionPage = Loadable(lazy(() => import('views/file-recognition')));

const UserManagmnetPage = Loadable(lazy(() => import('views/users-management')));
const OnlineUsersPage = Loadable(lazy(() => import('views/online-users')));
const ServerMonitoringPage = Loadable(lazy(() => import('views/server-monitoring')));
const ServerUpdatePage = Loadable(lazy(() => import('views/server-update')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <SocketProvider>
                <MainLayout />
            </SocketProvider>
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <MicrophoneRecognitionPage />
        },
        {
            path: '/microphone-recognition',
            element: <MicrophoneRecognitionPage />
        },
        {
            path: '/file-recognition',
            element: <FileRecognitionPage />
        },
        {
            path: '/dashboard',
            element: (
                <AdminGuard>
                    <Navigate to="/dashboard/users-managment" replace={true} />
                </AdminGuard>
            ),
        },
        {
            path: '/dashboard/users-managment',
            element: (
                <AdminGuard>
                    <UserManagmnetPage />
                </AdminGuard>
            ),
        },
        {
            path: '/dashboard/online-users',
            element: (
                <AdminGuard>
                    <OnlineUsersPage />
                </AdminGuard>
            ),
        },
        {
            path: '/dashboard/server-monitoring',
            element: (
                <AdminGuard>
                    <ServerMonitoringPage />
                </AdminGuard>
            ),
        },
        {
            path: '/dashboard/server-update',
            element: (
                <AdminGuard>
                    <ServerUpdatePage />
                </AdminGuard>
            ),
        }
    ]
};

export default MainRoutes;
